
import { ItiBaseDto } from '@/iti-core-vue';
import { Guid } from 'guid-typescript';
import { CategoryFourthLevel } from './category-fourth-level';
import { CategorySecondLevel } from './category-second-level';

export class CategoryThirdLevel extends ItiBaseDto {
    public code !: string;
    public description !: string;
    public categorySecondLevel !: CategorySecondLevel;
    public categoriesFourthLevel !: CategoryFourthLevel[];
    public externalID!: Guid;
}